module.exports = __webpack_public_path__ + "static/media/radiation.38b97536.svg";